"use client";

import { useQuery } from "@tanstack/react-query";
import { useAuthStore } from "@/store/auth.store";
import { orderService } from "@/services/order.service";
import type { OrdersHistoryParams } from "@/types";

export function useOngoingOrders() {
  const user = useAuthStore((s) => s.user);
  return useQuery({
    queryKey: ["orders", "ongoing"],
    queryFn: () => orderService.getOngoing(),
    enabled: !!user,
    staleTime: 0,
    refetchOnMount: "always",
    // No polling: the SSE stream (useCustomerOrdersSSE) invalidates this query
    // when an order's status changes or a new order appears. refetchOnWindowFocus
    // (default) covers the case where the SSE connection drops.
    throwOnError: false,
  });
}

export function useOrdersHistory(params: OrdersHistoryParams = {}) {
  const user = useAuthStore((s) => s.user);
  return useQuery({
    queryKey: ["orders", "history", params],
    queryFn: () => orderService.getHistory(undefined, params),
    enabled: !!user,
    staleTime: 0,
    refetchOnMount: "always",
    throwOnError: false,
  });
}

export function useOrderDetail(ulid: string | null) {
  const user = useAuthStore((s) => s.user);
  return useQuery({
    queryKey: ["orders", "detail", ulid],
    queryFn: () => orderService.getDetail(ulid!),
    enabled: !!user && !!ulid,
  });
}
